import firebaseConfig from 'src/assets/firebase.config.json';

export const environment = {
    production: true,
    apiEndPoint: 'https://dev-a-api.greatr.com.au/v1/web',
    FIREBASE_ENABLED: true,
    firebaseConfig: firebaseConfig
};